/**
 * Tax – Reports (VAT, Tax Audit, HMRC)
 */

export default {
  reports: {
    reports: "Reports",
    subtitle:
      "Company must keep tax records for 10 years. If you uploaded transactions in Lappa database they are available here for tax audit purposes during 10 years. We use special algorithms aligned with tax rules to determine customer location. If you need additional explanation you can contact our support center. Our tax experts would be pleased to help.",
    taxAudit: "Tax Audit",
    titles: {
      vatLiab: "VAT liabilities",
      vatLiabDesc:
        "If you like to check you VAT liabilities. Please note that this information are available not for every country. Please see FAQ section for more information.",
      vatObl: "View future VAT obligations",
      taxAudit: "Tax Audit report",
      taxAuditDesc:
        "Company must keep tax records for 10 years. If you uploaded transactions in Lappa database they are available here for tax audit purposes during 10 years. We use special algorithms aligned with tax rules to determine customer location. If you need additional explanation you can contact our support center. Our tax experts would be pleased to help.",
    },
    country: "Country",
    from: "From",
    till: "Till",
    tillLC: "till",
    reportType: "Report type",
    vatNumber: "VAT number",
    noTrans: "There are no transactions for this country in this period",
    buttons: {
      vatStatus: "Check VAT status",
      vatObl: "Check VAT obligations",
      taxAudit: "Create the tax audit report",
    },
    connectHMRC: "Please connect your HMRC account to submit declaration",
    connect: "Connect",
    close: "Close",
    showing: "Showing",
    of: "of",
    results: "results",
    transDate: "Transaction Date, Time",
    operator: "Operator",
    status: "Status",
    sum: "Amount",
    currency: "Currency",
    vat: "Vat",
    vatRate: "VAT Rate",
    vatType: "VAT type",
    custIP: "Customer IP",
    billingAddress: "Billing Address",
    payMethCountry: "Payment method country",
    custPhone: "Customer Phone Number",
    taxAuditTrans: "Tax Audit Transactions",
    allCountries: "All countries",
    forThePeriod: "for the period from",
    taxPeriod: "Tax Period",
    dueDate: "Due date",
    origAmount: "Original Amount (GBP)",
    outAmount: "Outstanding Amount (GBP)",
    period: "Period",
    periodKey: "Period Key",
    futureVatObl: "Future VAT obligations report",
    vlReport: "VAT liabilities report",
    hmrcInt: "HMRC integration",
    save: "Save",
    delete: "Delete",
    print: "Print",
    cancel: "Cancel",
    selectPlan: "Select plan",
  },
};
